module.exports = __webpack_public_path__ + "f7ff7a686f46df6068f1f1b9218a4160.pdf";